module.exports = __webpack_public_path__ + "/bundle/asset/U1_01-a0045e892a86afb54ffaa8172268f039.gif";